// import React, { useRef, useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { toast } from "react-toastify";
// import { providerVerify } from "../slice/providerPanelSlice";
// import { useNavigate } from "react-router-dom";

// const ProviderVerify = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const providerId = localStorage.getItem("user_id");

//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);
//   const [step, setStep] = useState(1); // 1: selfie, 2: front, 3: back, 4: review
//   const [cameraActive, setCameraActive] = useState(false); // Track camera stream status
//   const [formData, setFormData] = useState({
//     fileInputs: {
//       selfie: null,
//       front: null,
//       back: null,
//     },
//     previews: {
//       selfie: null,
//       front: null,
//       back: null,
//     },
//   });

//   useEffect(() => {
//     if (step <= 3) {
//       startCamera(currentField);
//     } else {
//       stopCamera(); // Ensure camera stops on review step
//     }
  
//     return () => {
//       stopCamera(); // Clean up camera on unmount or step change
//     };
//   }, [step]);

//   const stopCamera = () => {
//     const stream = videoRef.current?.srcObject;
//     if (stream) {
//       stream.getTracks().forEach((track) => track.stop());
//     }
//     if (videoRef.current) {
//       videoRef.current.srcObject = null;
//     }
//     setCameraActive(false);
//   };

//   const startCamera = async (field) => {
//     stopCamera(); // Stop any existing stream first
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({ video: true });
//       if (videoRef.current) {
//         videoRef.current.srcObject = stream;
//         setCameraActive(true); // Set camera active when stream is ready
//       }
//     } catch (error) {
//       alert("Camera access denied or not supported.");
//       setCameraActive(false);
//     }
//   };

//   const captureImage = (field) => {
//     const video = videoRef.current;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     canvas.width = video.videoWidth;
//     canvas.height = video.videoHeight;
//     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

//     canvas.toBlob((blob) => {
//       const file = new File([blob], `${field}.jpg`, { type: "image/jpeg" });
//       const previewUrl = URL.createObjectURL(blob);
//       setFormData((prev) => ({
//         ...prev,
//         fileInputs: {
//           ...prev.fileInputs,
//           [field]: file,
//         },
//         previews: {
//           ...prev.previews,
//           [field]: previewUrl,
//         },
//       }));
//       toast.success(`${field} captured successfully`);
//       stopCamera();
//     }, "image/jpeg");
//   };

//   const handleRetake = (field) => {
//     setFormData((prev) => ({
//       ...prev,
//       fileInputs: {
//         ...prev.fileInputs,
//         [field]: null,
//       },
//       previews: {
//         ...prev.previews,
//         [field]: null,
//       },
//     }));
//     startCamera(field);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const result = await dispatch(providerVerify({ formData, providerId }));

//     if (result.meta.requestStatus === "fulfilled") {
//       toast.success("Verification submitted!");
//       navigate("/provider/panel/info");
//     } else {
//       toast.error("Verification failed.");
//     }
//   };

//   const getCurrentField = () => {
//     switch (step) {
//       case 1:
//         return "selfie";
//       case 2:
//         return "front";
//       case 3:
//         return "back";
//       default:
//         return null;
//     }
//   };

//   const currentField = getCurrentField();

//   return (
//     <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
//       <form onSubmit={handleSubmit}>
//         <h5>Step {step}: {currentField ? `Capture ${currentField}` : "Review & Submit"}</h5>

//         {step <= 3 && (
//           <>
//             <div className="mb-3">
//               <label className="form-label text-capitalize">{currentField}</label>
//               <div className="d-flex align-items-center gap-3">
//                 {/* <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={() => startCamera(currentField)}
//                 >
//                   Start Camera
//                 </button> */}
//                 {formData.fileInputs[currentField] && (
//                   <span className="text-success">✅ Captured</span>
//                 )}
//               </div>
//             </div>

//             <div className="mb-3">
//               {formData.previews[currentField] ? (
//                 <>
//                   <img
//                     src={formData.previews[currentField]}
//                     alt={`${currentField} preview`}
//                     style={{ maxWidth: "100%", height: "auto" }}
//                   />
//                   <button
//                     type="button"
//                     className="btn btn-warning mt-2"
//                     onClick={() => handleRetake(currentField)}
//                   >
//                     Retake {currentField}
//                   </button>
//                 </>
//               ) : (
//                 <>
//                   <video ref={videoRef} autoPlay width="100%" />
//                   <canvas ref={canvasRef} style={{ display: "none" }} />
//                   <button
//                     type="button"
//                     onClick={() => captureImage(currentField)}
//                     className="btn btn-primary mt-2"
//                     disabled={!cameraActive}
//                   >
//                     Capture {currentField}
//                   </button>
//                 </>
//               )}
//             </div>
//           </>
//         )}

//         {step === 4 && (
//           <div className="mb-3">
//             <h6>Review Captured Images</h6>
//             {["selfie", "front", "back"].map((field) => (
//               <div key={field} className="d-flex align-items-center gap-3 mb-2">
//                 <span className="text-capitalize">{field}:</span>
//                 {formData.fileInputs[field] ? (
//                   <>
//                     <span className="text-success">✅ Captured</span>
//                     <img
//                       src={formData.previews[field]}
//                       alt={`${field} preview`}
//                       style={{ maxWidth: "100px", height: "auto" }}
//                     />
//                     <button
//                       type="button"
//                       className="btn btn-warning btn-sm"
//                       onClick={() => {
//                         setStep(["selfie", "front", "back"].indexOf(field) + 1);
//                         handleRetake(field);
//                       }}
//                     >
//                       Retake
//                     </button>
//                   </>
//                 ) : (
//                   <span className="text-danger">❌ Not Captured</span>
//                 )}
//               </div>
//             ))}
//             <button
//               type="submit"
//               className="btn btn-success mt-3"
//               disabled={!formData.fileInputs.selfie || !formData.fileInputs.front || !formData.fileInputs.back}
//             >
//               Submit Verification
//             </button>
//           </div>
//         )}

//         <div className="d-flex justify-content-between mt-4">
//           {step > 1 && (
//             <button
//               type="button"
//               className="btn btn-outline-secondary"
//               onClick={() => {
//                 stopCamera();
//                 setStep(step - 1);
//               }}
//             >
//               Previous
//             </button>
//           )}
//           {step < 4 && (
//             <button
//               type="button"
//               className="btn btn-outline-primary ms-auto"
//               onClick={() => {
//                 stopCamera();
//                 setStep(step + 1);
//               }}
//               disabled={step <= 3 && !formData.fileInputs[currentField]}
//             >
//               Next
//             </button>
//           )}
//         </div>
//       </form>
//     </div>
//   );
// };

// export default ProviderVerify;

import { useDispatch, useSelector } from "react-redux";
const ProviderVerify = () => {

  const { providersInfo: provider } = useSelector((state) => state.providerInfo);

  const navigateToEzverifi = () => {
  const client_id = process.env.REACT_APP_EZVERIFI_CLIENT_ID;
  const secret_key = process.env.REACT_APP_EZVERIFI_SECRET_KEY;
  const user_type = "provider"; // or "provider", if needed
  const user_id = localStorage.getItem("user_id");

  // Optional: Use real user names if available
  const firstName = provider.contact_name;
  const lastName = provider.contact_name1;

  // const firstName = "John";
  // const lastName = "Livone";

  const baseUrl = `https://portal.ezverifi.com/rest/apiverification/`;
  const url = `${baseUrl}?client_id=${client_id}&secret_key=${secret_key}&user_type=${user_type}&id=${user_id}&firstname=${firstName}&lastname=${lastName}`;

  window.open(url, "_blank");
};

  return (
<div className="col-md-8 col-xl-9 mt-4 mt-md-0">
      <div className="ps-2 ps-lg-4">
        <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
          Verification
        </h4>

        <div className="form-section mt-3 d-flex justify-content-center">
          <button className="btn btn-custom-primary w-50" onClick={navigateToEzverifi}>Verify with ezverifi</button>
        </div>
      </div>
    </div>
  );
};

export default ProviderVerify;